import { Component, OnInit } from "@angular/core";
import { Report, Transaction } from '../../report';
import { TransactionsService } from './transactions.service';
import * as moment from 'moment'
import { CurrentSessionService } from "src/app/shared/services/current-session.service";

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})

export class TransactionsComponent implements OnInit {
  public totalEntries!: number;
  public data!: Transaction[];
  public limit!: number;
  public requestBody: Report = {};
  public loading = false;
  isAssignedBusinessSelected: boolean = false;

  public tableColumns: string[] = [
    "name",
    "creditAmount",
    "creditCount",
    "cashAmount",
    "cashCount",
    "mobileWalletAmount",
    "mobileWalletCount",
    "fawryAmount",
    "fawryCount",
    "meezaAmount",
    "meezaCount",
    "nbe6MonthsAmount",
    "nbe6MonthsCount",
    "nbe12MonthsAmount",
    "nbe12MonthsCount",
    "nbe18MonthsAmount",
    "nbe18MonthsCount",
    "installmentsAmount",
    "installmentsCount",
  ];

  public displayTableColumns = {
    name: "Shop",
    creditAmount: "Credit Card Amount",
    creditCount: "Credit Card Count",
    cashAmount: "Cash Amount",
    cashCount: "Cash Count",
    mobileWalletAmount: "Mobile Wallet Amount",
    mobileWalletCount: "Mobile Wallet Count",
    fawryAmount: 'Fawry Amount',
    fawryCount: 'Fawry Count',
    meezaAmount: 'Meeza Amount',
    meezaCount: 'Meeza Count',
    nbe6MonthsAmount: 'NBE 6 Months Amount',
    nbe6MonthsCount: 'NBE 6 Months count',
    nbe12MonthsAmount: 'NBE 12 Months Amount',
    nbe12MonthsCount: 'NBE 12 Months count',
    nbe18MonthsAmount: 'NBE 18 Months Amount',
    nbe18MonthsCount: 'NBE 18 Months count',
    installmentsAmount: 'installments Amount',
    installmentsCount: 'installments count',
  };

  public totalNumberOfRecords!: number;
  public transactionReportData!: any[];

  constructor(
    public filterTrx: TransactionsService,
    private getCurrentSessionService: CurrentSessionService,
  ) { }

  async ngOnInit() {
    this.filterTrx.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };

    this.requestBody.filterOptions = {
      createdAt: {
        // @ts-ignore
        startDate: moment().startOf('month').toISOString(),
        // @ts-ignore
        endDate: moment().endOf('month').toISOString(),
      }
    };

    this.updateTable();
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      console.log("filter should not be null");
      this.requestBody.filterOptions = event;
    } else {
      console.log("filter should be null");
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.filterTrx.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.filterTrx.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.filterTrx.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = undefined;
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.filterTrx.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.filterTrx.activateLoader();
    if (this.isAssignedBusinessSelected){
      if(!this.requestBody['filterOptions']){
        this.requestBody['filterOptions'] = {}
      }
      const adminId =(await this.getCurrentSessionService.make())?.data?.userId;
      this.requestBody['filterOptions']['adminId'] = adminId
    } else {
      delete this.requestBody?.filterOptions?.adminId
    }
    if(!this.requestBody.filterOptions?.createdAt){
      this.requestBody.filterOptions['createdAt'] = {
        // @ts-ignore
        startDate: moment().startOf('month').toISOString(),
        // @ts-ignore
        endDate: moment().endOf('month').toISOString(),
      }
    }
    // this.salesReportService.deactivateLoader();
    console.log('requestBody :', this.requestBody);
    this.filterTrx.setParams(this.requestBody);
    const report = await this.filterTrx.make();
    this.transactionReportData = report.result.map((e: any) => {
      return this.getMappedTransactionRow(e);
    });
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  getMappedTransactionRow(row: any) {
    let mappedRow:any = {};
    this.tableColumns.forEach((column: string) => {
      mappedRow[column] = row[column] != 0 ? row[column] : '0';
    });
    return mappedRow;
  }

  assignedBusinessesFilterChanged(value){
    this.isAssignedBusinessSelected = value;
  }
}
